'use client'
import { LuneTheme } from '@lune-fe/lune-ui-lib'
import ArrowForwardOutlinedIcon from '@mui/icons-material/ArrowForwardOutlined'
import Box from '@mui/material/Box'
import Text from '@mui/material/Typography'
import { isFilled } from '@prismicio/helpers'
import { BlogpostSlicedDocumentDataBodyDeepDiveSlice } from '@root/prismicio-types'
import Image from 'next/image'
import Link from 'next/link'

import { RenderOn } from '@/utills/DeviceUtils'

export const DeepDive = ({ slice }: { slice: BlogpostSlicedDocumentDataBodyDeepDiveSlice }) => {
    const { palette } = LuneTheme

    const deepDive = slice.primary
    const title = deepDive.dive_title[0]?.text
    const description = deepDive.dive_description
    const link = deepDive.dive_link
    const image = deepDive.image
    const bgColor = deepDive.background_color

    if (
        !isFilled.title(deepDive.dive_title) ||
        !isFilled.keyText(deepDive.dive_description) ||
        !isFilled.link(deepDive.dive_link) ||
        !('url' in link)
    ) {
        throw new Error('Unexpected property type(s)')
    }

    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                my: {
                    xs: 5,
                    sm: 15,
                    md: 15,
                    lg: 15,
                    xl: 15,
                },
                a: {
                    textDecoration: 'none',
                    color: palette.Grey900,
                },
            }}
        >
            <Link href={link.url!} target={'target' in link ? link.target : '_self'}>
                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                        maxWidth: '720px',
                        gap: 3,
                        borderRadius: '16px',
                        backgroundColor: bgColor,
                        padding: '24px 16px',
                    }}
                >
                    {isFilled.image(image) && image.url && (
                        <Box
                            sx={{
                                width: '48px',
                                height: '48px',
                                borderRadius: '100%',
                                overflow: 'hidden',
                                flex: '1 0 48px',
                            }}
                        >
                            <Image
                                width={48}
                                height={48}
                                src={image.url}
                                alt={image.alt || 'deep-dive-image'}
                            />
                        </Box>
                    )}
                    <Box
                        sx={{
                            display: 'flex',
                            flexDirection: 'row',
                            alignItems: 'center',
                            gap: 1,
                        }}
                    >
                        <RenderOn breakPoints={['xl', 'lg']}>
                            <Text variant={'body1'}>{title}</Text>
                            <Text variant={'body3'}>{description}</Text>
                        </RenderOn>
                        <RenderOn breakPoints={['md', 'sm', 'xs']}>
                            <Text variant={'body2'}>{title}</Text>
                            <Text variant={'caption'}>{description}</Text>
                        </RenderOn>
                    </Box>
                    <ArrowForwardOutlinedIcon />
                </Box>
            </Link>
        </Box>
    )
}
